import React, { Fragment } from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import CallRailAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/CallRailAppIcon';

const CallRailStrategy = {
  previewInfo: {
    name: 'CallRail',
    iconSvg: <CallRailAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'CallRail',
    category: 'Productivity',
    details: (
      <>
        Tracking and analytics for phone calls and web forms
        <br />
        Discover which ads, keywords, and campaigns bring valuable leads over the phone and on the web.
        <br />
        <br />
        Make more money by identifying the marketing channels that make your phone ring. Measure the phone leads you
        receive from your offline marketing efforts, including direct mail, newspaper, radio, TV, and printed brochures.
        Learn more about your customers and your campaigns so you can be even more effective and close more sales.
      </>
    ),
    iconSvg: <CallRailAppIcon size="xlarge" />,
  },
  media: {
    youtubeId: null,
  },
  sellingPoints: {
    headline: '',
    description: '',
    orderedPoints: '',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://callrail.com/pricing" target="_blank" rel="noreferrer">
              https://callrail.com/pricing
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            Starting at $45/month
          </Typography>
        </Grid>
      </Grid>
    ),
    disclaimer: 'Enabling this toggle will share your contact information with the partner',
  },
  supportContacts: [],
};

export default CallRailStrategy;
